const translationEN = {
  metaDescription : "No Motor Show. But everywhere in the streets. Discover our Motor Show Conditions.",

  // HEADER 
  mainURL: "https://www.volvocars.com/",
  BMSMessage1 : "This year, the Brussels Motor Show will not take place. <br /> But luckily, we are everywhere else. <br /> <br />Moving nicely or parked along a sidewalk, your future Volvo is surely not far away.",
  BMSMessage2 : "We sent 3 street photographers on our streets to capture all Volvo models.<br />Discover them&nbsp;here.",
  meetPhotographers : "Meet our street photographers",
  scrollDown : "Scroll to discover our models and our Brussels Motor Show Conditions.",
  btnHeader : "Discover our Street Configurator",
  linkXC40 : "https://www.volvocars.com/fr-be/v/cars/xc40",
  linkXC60 : "https://www.volvocars.com/fr-be/v/cars/xc60",
  linkXC90 : "https://www.volvocars.com/fr-be/v/cars/xc90",
  linkV60 : "https://www.volvocars.com/fr-be/v/cars/v40",

  // MENU
  ourCars: "Our cars",
  ourCarsLink: "https://www.volvocars.com/fr-be/modeles",
  item1 : "Configurator",
  linkItem1 : "https://www.volvocars.com/fr-be/build",
  item2 : "Drive an electric Volvo",
  linkItem2 : "https://www.volvocars.com/fr-be/v/cars/electric-cars",
  item3 : "Find a retailer",
  linkItem3 : "https://www.volvocars.com/fr-be/dealers/distributeurs",
  item4 : "Contact",
  linkItem4 : "https://www.volvocars.com/fr-be/contact",
  switchLanguage: "Belgium (Nederlands)", 

  // MAIN
  footerMain: "You spotted a Volvo&nbsp;? Try our Street Configurator",
  

  //CASES
  ctaAllCaseTop : "Request an offer",
  ctaAllCaseTopLink : "https://www.volvocars.com/fr-be/quote?campaigncode=Brus-motorshow-2022-B_VCBE",
  //CASE1 - XC40
  case1Photographer : "© Thomas Switn Sweertvaegher, Ottergemsesteenweg – 9000 Gent",
  case1Copy1 : "Plug-in Hybrid R-Design",
  case1Copy2 : "Ice White <br />18” wheels",
  case1Copy3 : "Basic model starting at <span>32.800&nbsp;€</span>",
  case1CtaImage : "Discover the&nbsp;XC40",
  case1LinkCtaImage : "https://www.volvocars.com/fr-be/v/cars/xc40",
  case1Cta : "Discover our <br /> Motor Show Conditions",
  case1Link : "https://www.volvocars.com/fr-be/l/offres/b2c/xc40 ",
  //CASE2 - XC60
  case2Photographer : "© Wouter Van Vaerenbergh, Kwatrechtstraat – 9230 Wetteren",
  case2Copy1 : "Plug-in Hybrid R-Design",
  case2Copy2 : "Silver Dawn <br />19” wheels",
  case2Copy3 : "Basis model starting at <span>51.200&nbsp;€</span>",
  case2CtaImage : "Discover the&nbsp;XC60",
  case2LinkCtaImage : "https://www.volvocars.com/fr-be/v/cars/xc60",
  case2Cta : "Discover our <br /> Motor Show Conditions",
  case2Link : "https://www.volvocars.com/fr-be/l/offres/b2c/xc60",
  //CASE3 - XC90
  case3Photographer : "© Thomas Switn Sweertvaegher, Nieuwevaart - 9000 Gent",
  case3Copy1 : "Mild Hybrid Inscription",
  case3Copy2 : "Birch Light <br />21” wheels",
  case3Copy3 : "Basis model starting at <span>73.840&nbsp;€</span>",
  case3CtaImage : "Discover the&nbsp;XC90",
  case3LinkCtaImage : "https://www.volvocars.com/fr-be/v/cars/xc90",
  case3Cta : "Discover our <br /> Motor Show Conditions",
  case3Link : "https://www.volvocars.com/fr-be/l/offres/b2c/xc90",
  //CASE4 - V60
  case4Photographer : "© Thomas Switn Sweertvaegher, Rodebergstraat - 8950 Heuvelland",
  case4Copy1 : "Mild Hybrid Momentum Pro",
  case4Copy2 : "Pebble Grey <br />19” wheels",
  case4Copy3 : "Basis model starting at <span>40.550&nbsp;€</span>",
  case4CtaImage : "Discover the&nbsp;V60",
  case4LinkCtaImage : "https://www.volvocars.com/fr-be/v/cars/v60",
  case4Cta : "Discover our <br /> Motor Show Conditions",
  case4Link : "https://www.volvocars.com/fr-be/l/offres/b2c/v60",
  //VIDEO
  videoCtaImage : "Play&nbsp;full <br /> Video",
  videoCtaImageStop : "Pause <br /> Video",
  ctaVideo : "Discover our street photographers",
  seeMore : "Discover more",
  videoURL : "https://player.vimeo.com/video/654445872?h=0209810e13",

  //FOOTER 
  footer1: "Discover all our offers",
  footer1Link: "https://www.volvocars.com/fr-be/acheter/votre-nouvelle-volvo/offres",
  footer2: "Find a retailer",
  footer2Link: "https://www.volvocars.com/fr-be/dealers/distributeurs ",
  footer3: "Try our Street Configurator",

  linkStreetConfigurator: "https://volvostreetconfigurator.be/en",

}

export default translationEN;